export const FETCH_INTERVIEWERS_REQUEST =
  "interviewers/FETCH_INTERVIEWERS_REQUEST";
export const FETCH_INTERVIEWERS_SUCCESS =
  "interviewers/FETCH_INTERVIEWERS_SUCCESS";
export const FETCH_INTERVIEWERS_FAILURE =
  "interviewers/FETCH_INTERVIEWERS_FAILURE";
export const CLEAR_INTERVIEWERS = "interviewers/CLEAR_INTERVIEWERS";
